export const phoneNumberFormatter = (phoneNumber) => {
  if (!phoneNumber) {
    return "";
  }
  const phoneNumberString = phoneNumber.toString();
  const firstPart = phoneNumberString.slice(0, 3);
  const secondPart = phoneNumberString.slice(3, 5);
  const thirdPart = phoneNumberString.slice(5, 8);
  const fourthPart = phoneNumberString.slice(8, 10);
  const fifthPart = phoneNumberString.slice(10, 12);
  return `+${firstPart} ${secondPart} ${thirdPart} ${fourthPart} ${fifthPart}`;
};
